import React, { useEffect, useState } from "react"

// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import { AdminHeader } from "shared/components/common/AdminHeader"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"

import { Card, CardContent, CardHeader, Chip, Tooltip } from "@mui/material"

import MDBox from "components/MDBox"
import UIDataTable from "components/UIDataTable/UIDataTable"
import ButtonAdminAddNew from "components/Button/ButtonAdminAddNew"

import { Loading } from "shared/components/ui/Loading"
import { TableUtil } from "utilities/tableUtil"

// Icon
import CustomEyeIcon from "components/icons/CustomEyeIcon"
import CustomApproveIcon from "components/icons/CustomApproveIcon"
import CustomRejectIcon from "components/icons/CustomRejectIcon"
import ModalApproveLeave from "components/ModalApproveLeave/ModalApproveLeave"
import ModalReasonDenyLeave from "components/ModalReasonDenyLeave/ModalReasonDenyLeave"

// Redux
import { useLazyGetLeaveRequestQuery } from "shared/redux/endpoints/leaveRequest"
import {
  useApproveLeaveRequestAdminMutation,
  useRejectLeaveRequestAdminMutation,
} from "shared/redux/endpoints/employee"
import moment from "moment"

const DATE_FORMAT = "DD/MM/YYYY HH:mm"

const calculateLeaveDays = (startDate, endDate, isHalfDay) => {
  const start = moment(startDate)
  const end = moment(endDate)
  let totalLeaveNumber = end.diff(start, "days") + 1
  if (isHalfDay) {
    totalLeaveNumber = totalLeaveNumber - 0.5
  }
  return totalLeaveNumber
}

export const LeaveRequest = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [dataTable, setDataTable] = useState({
    columns: [
      { id: "id", label: "ID", format: (id) => <p>{id}</p> },
      {
        id: "userId",
        label: "Teacher name",
        format: (userObj) => {
          return (
            <div className="avatar-wrapper">
              <img
                src={userObj.avatar || "https://placehold.co/180x180"}
                className="avatar avatar-sm me-2"
                alt="user1"
              />
              <p className="name">Demo</p>
            </div>
          )
        },
      },
      {
        id: "leaveType",
        label: "Leave Type",
        format: (obj) => {
          return <p>{obj.label}</p>
        },
      },
      {
        id: "created",
        label: "Submit Date",
        format: (date) => {
          return <p>{moment(date).format(DATE_FORMAT)}</p>
        },
      },
      {
        id: "startDate",
        label: "Start Date",
        format: (date) => {
          return <p>{moment(date).format(DATE_FORMAT)}</p>
        },
      },
      {
        id: "endDate",
        label: "End Date",
        format: (date) => {
          return <p>{moment(date).format(DATE_FORMAT)}</p>
        },
      },
      {
        id: "totalLeaveNumber",
        label: "Total Leave Number",
        format: (value) => (
          <p>
            {value} {value > 1 ? "days" : "day"}
          </p>
        ),
      },
      {
        id: "status",
        label: "Status",
        format: (obj) => {
          if (!obj || !obj.label) return
          let labelLowerCase = obj.label.toLowerCase()
          return (
            <Chip
              className={`chip-status chip-status-${labelLowerCase}`}
              label={obj.label}
            />
          )
        },
      },
      {
        id: "action",
        label: "Action",
        styleHeader: { textAlign: "right" },
        format: (value, item) => {
          return (
            <div className="action-wrap">
              <Tooltip title={`Update`} enterDelay={2000}>
                <div
                  onClick={() => {
                    handlerAction(item, "update")
                  }}
                >
                  <CustomEyeIcon />
                </div>
              </Tooltip>
              <Tooltip title={`Approve`} enterDelay={2000}>
                <div
                  onClick={() => {
                    handlerAction(item, "approve")
                  }}
                >
                  <CustomApproveIcon />
                </div>
              </Tooltip>
              <Tooltip title={`Reject`} enterDelay={2000}>
                <div
                  onClick={() => {
                    handlerAction(item, "reject")
                  }}
                >
                  <CustomRejectIcon />
                </div>
              </Tooltip>
            </div>
          )
        },
      },
    ],
    rows: [],
  })

  const [pagination, setPagination] = useState({
    currentPage: 0,
    pageSize: 5,
    totalPage: 0,
    totalElement: 0,
    order: {
      column: "id",
      direction: "asc",
    },
  })

  const [state, setState] = useState({
    page: pagination.currentPage,
    size: pagination.pageSize,
    search: "",
    order: `${pagination.order.column},${pagination.order.direction}`,
  })

  const [triggerLeaveRequest, { data: response }] =
    useLazyGetLeaveRequestQuery()
  const [approveLeaveRequest] = useApproveLeaveRequestAdminMutation()
  const [rejectLeaveRequest] = useRejectLeaveRequestAdminMutation()
  const [isOpenApproveModal, setIsOpenApproveModal] = useState(false)
  const [isOpenRejectModal, setIsOpenRejectModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const fetchOptions = async (params) => {
    setIsLoading(true)
    await triggerLeaveRequest(params)
      .then((res) => handleDataTable(res.data))
      .finally(() => setIsLoading(false))
  }

  const handleDataTable = (response) => {
    console.log(response, "response")
    const { data } = response

    setDataTable({
      ...dataTable,
      rows:
        data?.map((item) => {
          const startDate = moment(item.startDate)
          const endDate = moment(item.endDate)
          const totalLeaveNumber = calculateLeaveDays(
            startDate,
            endDate,
            item.halfDay
          )

          return {
            id: item.id,
            userId: item.userId,
            leaveType: item.leaveType,
            startDate: item.startDate,
            endDate: item.endDate,
            totalLeaveNumber: totalLeaveNumber,
            status: item.statusInfo,
          }
        }) || [],
    })

    setState({
      ...state,
      page: response?.currentPage,
      size: response?.pageSize,
    })
    setPagination({
      ...pagination,
      totalPage: response?.totalPage,
      totalElement: response?.totalElement,
    })
  }

  const handleAddNew = () => {
    alert("Add New")
  }

  const handleApprove = async (item) => {
    if (!item?.id) return
    await approveLeaveRequest(item.id)
    setIsOpenApproveModal(true)
    fetchOptions(state)
  }

  const handleReject = async (reason) => {
    if (!selectedItem?.id) return
    await rejectLeaveRequest({
      id: selectedItem.id,
      rejectionReason: reason,
    })
    setIsOpenRejectModal(false)
    setSelectedItem(null)
    fetchOptions(state)
  }

  const handlerAction = (item, action) => {
    switch (action) {
      case "update":
        alert("Update")
        break
      case "approve":
        handleApprove(item)
        break
      case "reject":
        setSelectedItem(item)
        setIsOpenRejectModal(true)
        break
      default:
        break
    }
  }

  const propsUIDataTable = {
    className: "table-mgr-leave-request-container",
    isLoading,
    columns: dataTable.columns,
    rows: dataTable.rows,
    currentPage: state.page,
    pageSize: state.size,
    search: state.search,
    order: pagination.order.direction,
    orderBy: pagination.order.column,
    totalPage: pagination.totalPage,
    totalElement: pagination.totalElement,
    onChangePage: async (event, value) => {
      if (value === state.page + 1) return
      await fetchOptions({
        ...state,
        page: value - 1,
      })
    },
    onChangePageSize: async (event) => {
      await fetchOptions({
        ...state,
        size: event.target.value,
      })
    },
  }

  useEffect(() => {
    fetchOptions(state)
  }, [])

  return (
    <DashboardLayout>
      <AdminHeader />
      <DashboardNavbar light />
      <MDBox className="admin-mgr-link-container">
        <Card>
          {isLoading && (
            <Loading
              style={{ width: 250, height: 200, margin: "150px auto" }}
            />
          )}
          {!isLoading && (
            <>
              <CardHeader
                className="card-header"
                title="Leave Request"
                action={<ButtonAdminAddNew onClick={handleAddNew} />}
              />
              <CardContent>
                <UIDataTable {...propsUIDataTable} />
              </CardContent>
            </>
          )}
          {/* <DialogCreateOrUpdateLink {...propertiesModalCreateOrUpdateLink} /> */}
        </Card>
      </MDBox>
      <ModalApproveLeave
        isOpen={isOpenApproveModal}
        onClose={() => setIsOpenApproveModal(false)}
        onSubmit={() => setIsOpenApproveModal(false)}
      />
      <ModalReasonDenyLeave
        isOpen={isOpenRejectModal}
        onClose={() => setIsOpenRejectModal(false)}
        onSubmit={handleReject}
      />
    </DashboardLayout>
  )
}
